import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ba1b61e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-back" }, null, -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-back" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_share_menu = _resolveComponent("share-menu")!
  const _component_share_by_network = _resolveComponent("share-by-network")!
  const _component_share_by_message = _resolveComponent("share-by-message")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_shared_page = _resolveComponent("shared-page")!
  const _component_drive_menu_pop_up = _resolveComponent("drive-menu-pop-up")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_bottom_pop_up, {
          onHide: _ctx.hidePopUp,
          "hide-bottom-decoration": "",
          "hide-top-decoration": ""
        }, _createSlots({
          title: _withCtx(() => [
            (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.MENU)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.shareTitle), 1)
                ], 64))
              : (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.SHARE_BY_NETWORK)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchState(_ctx.CASE_SHARE_POPUP_STATES.MENU)))
                  }, [
                    _hoisted_2,
                    _createTextVNode(" " + _toDisplayString(_ctx.$localize('share.popup.backtext')), 1)
                  ]))
                : _createCommentVNode("", true)
          ]),
          body: _withCtx(() => [
            (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.MENU)
              ? (_openBlock(), _createBlock(_component_share_menu, {
                  key: 0,
                  itemType: _ctx.itemType,
                  onSwitchState: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchState($event)))
                }, null, 8, ["itemType"]))
              : (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.SHARE_BY_NETWORK)
                ? (_openBlock(), _createBlock(_component_share_by_network, {
                    key: 1,
                    "group-list": _ctx.groupList,
                    "contact-list": _ctx.contactList,
                    "selected-all": _ctx.selectedAll,
                    "deselected-all": _ctx.deselectedAll,
                    onOnSelectAll: _ctx.onSelectAll,
                    onOnDeselectAll: _ctx.onDeselectAll,
                    onOnSelectContact: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSelectContact($event))),
                    onOnSelectGroup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSelectGroup($event))),
                    onOpenSpecificPeople: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sharedPage = _ctx.SHARE_ACCESS.SPECIFIC_PEOPLE)),
                    onOpenGroups: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sharedPage = _ctx.SHARE_ACCESS.GROUP))
                  }, null, 8, ["group-list", "contact-list", "selected-all", "deselected-all", "onOnSelectAll", "onOnDeselectAll"]))
                : (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.SHARE_BY_MESSAGE)
                  ? (_openBlock(), _createBlock(_component_share_by_message, {
                      key: 2,
                      "contact-list": _ctx.myContacts,
                      "group-list": _ctx.myGroups,
                      "item-id": _ctx.item.id!,
                      "item-owner-id": _ctx.item.owner.accountId,
                      "item-share-settings": _ctx.item.shareSettings,
                      "item-type": _ctx.itemType,
                      onBack: _cache[7] || (_cache[7] = ($event: any) => (_ctx.stateController = _ctx.CASE_SHARE_POPUP_STATES.MENU)),
                      onOnShare: _ctx.onShareByMessage
                    }, null, 8, ["contact-list", "group-list", "item-id", "item-owner-id", "item-share-settings", "item-type", "onOnShare"]))
                  : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.SHARE_BY_NETWORK)
            ? {
                name: "top-right",
                fn: _withCtx(() => [
                  _createElementVNode("h5", {
                    class: "right bold",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onShareAccess && _ctx.onShareAccess(...args)))
                  }, _toDisplayString(_ctx.$localize('share.popup.done.button')), 1)
                ])
              }
            : undefined
        ]), 1032, ["onHide"]),
        (_ctx.sharing)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: "Sharing..."
            }))
          : _createCommentVNode("", true),
        (_ctx.sharedPage)
          ? (_openBlock(), _createBlock(_component_shared_page, {
              key: 1,
              "contact-list": _ctx.myContacts,
              "group-list": _ctx.myGroups,
              type: _ctx.sharedPage,
              onOnSelect: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSelectFromPage($event))),
              onBack: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sharedPage = null)),
              onDone: _ctx.onShareAccess
            }, null, 8, ["contact-list", "group-list", "type", "onDone"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_drive_menu_pop_up, {
          positionData: _ctx.positionData,
          onHide: _ctx.hidePopUp,
          "hide-bottom-decoration": "",
          "hide-top-decoration": ""
        }, _createSlots({
          title: _withCtx(() => [
            (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.MENU)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.shareTitle), 1)
                ], 64))
              : (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.SHARE_BY_NETWORK)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.switchState(_ctx.CASE_SHARE_POPUP_STATES.MENU)))
                  }, [
                    _hoisted_4,
                    _createTextVNode(" " + _toDisplayString(_ctx.$localize('share.popup.backtext')), 1)
                  ]))
                : _createCommentVNode("", true)
          ]),
          body: _withCtx(() => [
            (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.MENU)
              ? (_openBlock(), _createBlock(_component_share_menu, {
                  key: 0,
                  itemType: _ctx.itemType,
                  onSwitchState: _cache[12] || (_cache[12] = ($event: any) => (_ctx.switchState($event)))
                }, null, 8, ["itemType"]))
              : (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.SHARE_BY_NETWORK)
                ? (_openBlock(), _createBlock(_component_share_by_network, {
                    key: 1,
                    "group-list": _ctx.groupList,
                    "contact-list": _ctx.contactList,
                    "selected-all": _ctx.selectedAll,
                    "deselected-all": _ctx.deselectedAll,
                    onOnSelectAll: _ctx.onSelectAll,
                    onOnDeselectAll: _ctx.onDeselectAll,
                    onOnSelectContact: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSelectContact($event))),
                    onOnSelectGroup: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSelectGroup($event))),
                    onOpenSpecificPeople: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sharedPage = _ctx.SHARE_ACCESS.SPECIFIC_PEOPLE)),
                    onOpenGroups: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sharedPage = _ctx.SHARE_ACCESS.GROUP))
                  }, null, 8, ["group-list", "contact-list", "selected-all", "deselected-all", "onOnSelectAll", "onOnDeselectAll"]))
                : (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.SHARE_BY_MESSAGE)
                  ? (_openBlock(), _createBlock(_component_share_by_message, {
                      key: 2,
                      "contact-list": _ctx.myContacts,
                      "group-list": _ctx.myGroups,
                      "item-id": _ctx.item.id!,
                      "item-owner-id": _ctx.item.owner.accountId,
                      "item-share-settings": _ctx.item.shareSettings,
                      "item-type": _ctx.itemType,
                      onBack: _cache[17] || (_cache[17] = ($event: any) => (_ctx.stateController = _ctx.CASE_SHARE_POPUP_STATES.MENU)),
                      onOnShare: _ctx.onShareByMessage
                    }, null, 8, ["contact-list", "group-list", "item-id", "item-owner-id", "item-share-settings", "item-type", "onOnShare"]))
                  : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (_ctx.stateController === _ctx.CASE_SHARE_POPUP_STATES.SHARE_BY_NETWORK)
            ? {
                name: "top-right",
                fn: _withCtx(() => [
                  _createElementVNode("h5", {
                    class: "right bold",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onShareAccess && _ctx.onShareAccess(...args)))
                  }, _toDisplayString(_ctx.$localize('share.popup.done.button')), 1)
                ])
              }
            : undefined
        ]), 1032, ["positionData", "onHide"]),
        (_ctx.sharing)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: "Sharing..."
            }))
          : _createCommentVNode("", true),
        (_ctx.sharedPage)
          ? (_openBlock(), _createBlock(_component_shared_page, {
              key: 1,
              "contact-list": _ctx.myContacts,
              "group-list": _ctx.myGroups,
              type: _ctx.sharedPage,
              onOnSelect: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onSelectFromPage($event))),
              onBack: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sharedPage = null)),
              onDone: _ctx.onShareAccess
            }, null, 8, ["contact-list", "group-list", "type", "onDone"]))
          : _createCommentVNode("", true)
      ]))
}